import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { Title } from 'components/layout'
import { ConfigKey } from 'containers/forms/configuration'
import { ConfigurationKeySetModal } from 'components/modals'
import { CONFIGURATION_KEYS } from 'constants/enums'

export default class PaymentMethods extends Component {
  static propTypes = {
    configuration: PropTypes.object,
    activeOrganization: PropTypes.object,
    route: PropTypes.object,
    organisationId: PropTypes.number,
    isSameLevel: PropTypes.bool,
    modal: PropTypes.func,
    onUpdateConfigKey: PropTypes.func,
    onResetConfigKey: PropTypes.func,
    reset: PropTypes.func,
    change: PropTypes.func,
    initialize: PropTypes.func,
    isConfigUpdating: PropTypes.bool,
    handleSubmit: PropTypes.func,
    contacts: PropTypes.object
  }

  static defaultProps = {
    params: {},
    configuration: {
      values: {}
    }
  }

  state = {
    config: {}
  }

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  render() {
    const {
      activeOrganization,
      isSameLevel,
      handleSubmit,
      configuration,
      route,
      organisationId,
        contacts
    } = this.props

      const editCustomizationEnabled = get(contacts, 'active.editCustomizationEnabled')

    return (
      <div>
        <Title h2 intlKey="moduleTitle.global_payment_method">
          Global payment method
        </Title>

        <ConfigKey
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.onlineMasterCardPayment.id}]`
          )}
          onConfigEdit={this.handleChangeConfig}
          activeOrganization={activeOrganization}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          standalone
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
        <ConfigKey
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.onlinePayPalPayment.id}]`
          )}
          onConfigEdit={this.handleChangeConfig}
          activeOrganization={activeOrganization}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          standalone
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
        <ConfigKey
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.onlineManualPayment.id}]`
          )}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          activeOrganization={activeOrganization}
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
        <ConfigKey
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.directPayment.id}]`
          )}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          activeOrganization={activeOrganization}
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
        <ConfigKey
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.notRequiredPayment.id}]`
          )}
          onConfigEdit={this.handleChangeConfig}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          activeOrganization={activeOrganization}
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
          <ConfigKey
              onConfigEdit={this.handleChangeConfig}
              config={get(
                  configuration,
                  `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.directTransferPayment.id}]`
              )}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              activeOrganization={activeOrganization}
              isSameLevel={isSameLevel}
              compact
              editCustomizationEnabled={editCustomizationEnabled}
          />
          <ConfigKey
              onConfigEdit={this.handleChangeConfig}
              config={get(
                  configuration,
                  `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.gpWebPayPayment.id}]`
              )}
              options={{
                  isTypeId: get(route, 'isTypeId')
              }}
              activeOrganization={activeOrganization}
              isSameLevel={isSameLevel}
              compact
              editCustomizationEnabled={editCustomizationEnabled}
          />
        <ConfigKey
          onConfigEdit={this.handleChangeConfig}
          config={get(
            configuration,
            `valuesByOrganizationId[${organisationId}][${CONFIGURATION_KEYS.manualImageTransactionPayment.id}]`
          )}
          options={{
            isTypeId: get(route, 'isTypeId')
          }}
          activeOrganization={activeOrganization}
          isSameLevel={isSameLevel}
          compact
          editCustomizationEnabled={editCustomizationEnabled}
        />
        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
        />
      </div>
    )
  }
}
